var _rect, _polygon;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGalleryVideo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 400,
    height: 300,
    viewBox: "0 0 400 300",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 5,
    width: 390,
    height: 290,
    rx: 20,
    fill: "#fff",
    stroke: "#000",
    strokeWidth: 10
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "170,110 270,150 170,190",
    fill: "#ff4444"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGalleryVideo);
export default __webpack_public_path__ + "static/media/gallery-video.f6d64a9a213b0fc3fab36d966c504277.svg";
export { ForwardRef as ReactComponent };